import React from 'react'

const NotFound = () => {
  return (
    <div className="abnb-list-main-cont">
      <h1 className="listing-title mb-3">404 Not Found</h1>
      <a href="/">Click here</a> to go back to the homepage.
    </div>
  )
}

export default NotFound